(function () {
  // Main tab switching
  var mainTabs  = document.querySelectorAll('#cean-tabs-main > div');
  var mainPanes = document.querySelectorAll('.cean-sg__pane');

  function setMainTab(name) {
    mainTabs.forEach(function(t)  { t.classList.toggle('active', t.dataset.pane === name); });
    mainPanes.forEach(function(p) { p.classList.toggle('active', p.dataset.pane === name); });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  mainTabs.forEach(function(t) {
    t.addEventListener('click', function() { setMainTab(t.dataset.pane); });
  });

  var switchBtn = document.getElementById('cean-switch-btn');
  if (switchBtn) switchBtn.addEventListener('click', function() { setMainTab('size-guide'); });

  // Chat / ZipChat embed
  var inputBar   = document.getElementById('cean-input-bar');
  var inputField = document.getElementById('cean-chat-input');
  var submitBtn  = document.getElementById('cean-chat-submit');
  var iframeWrap = document.getElementById('cean-iframe-wrap');
  var placeholder = document.getElementById('cean-chat-placeholder');
  var chatBody   = document.getElementById('cean-chat-body');

  function startChat() {
    if (iframeWrap.querySelector('iframe')) return;
    chatBody.classList.add('expanded');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://app.zipchat.ai/iframe/?widget_token=Dj1GWOS6ZzDBonw6VsaO';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'microphone *');
    iframe.setAttribute('width', '100%');
    iframeWrap.appendChild(iframe);
    iframeWrap.classList.add('active');
    placeholder.style.display = 'none';
  }

  inputBar.addEventListener('click', function(e) {
    if (e.target === submitBtn || submitBtn.contains(e.target)) return;
    inputField.focus();
  });
  inputField.addEventListener('focus', startChat);
  submitBtn.addEventListener('click', function(e) { e.stopPropagation(); startChat(); });
  inputBar.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inputField.focus(); }
  });

  // Product group selector
  var productTabs  = document.querySelectorAll('.cean-sg__product-tab');
  var groupButtons = document.querySelectorAll('#cean-group-selector button');

  function setGroup(g) {
    productTabs.forEach(function(t)  { t.classList.toggle('active', t.dataset.product === g); });
    groupButtons.forEach(function(b) { b.classList.toggle('active', b.dataset.g === g); });
  }
  groupButtons.forEach(function(b) {
    b.addEventListener('click', function() { setGroup(b.dataset.g); });
  });

  // Unit toggle (IN / CM)
  var unitButtons = document.querySelectorAll('#cean-unit-toggle > div');

  function setUnit(u) {
    document.querySelectorAll('[data-in]').forEach(function(el) {
      el.textContent = el.dataset[u];
    });
    unitButtons.forEach(function(b) { b.classList.toggle('active', b.dataset.u === u); });
  }
  unitButtons.forEach(function(b) {
    b.addEventListener('click', function() { setUnit(b.dataset.u); });
  });
})();